import React, { FocusEventHandler, FormEventHandler } from 'react';
import { connect } from 'dva';
import { Dispatch } from 'redux';

import { Field } from '../../../declarations/widget-ums';
import TextField from '../TextField/TextField';
import { getOnChange, trimOnBlur } from '../../../helpers/handlers';
import { getPersonPlaceholder } from '../../../helpers/getPlacelholder';

export interface Props {
  onChange: FormEventHandler;
  onBlur: FocusEventHandler;
  birthPlace: Field<string>;
  model: string;
}

function BirthPlace({ onChange, onBlur, birthPlace }: Props) {
  return (
    <div className="PguFormGrid__row">
      <div className="PguFormGrid_col">
        <TextField
          key="birthPlace"
          className="PguFormGrid__field"
          placeholder={getPersonPlaceholder('birthPlace')}
          inputProps={{
            maxLength: 500,
            name: 'birthPlace',
            ...birthPlace,
            onChange,
            onBlur,
          }}
        />
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch: Dispatch, { model }) => ({
  onChange: getOnChange(model, dispatch),
  onBlur: trimOnBlur(model, dispatch),
});

export default connect(() => ({}), mapDispatchToProps)(BirthPlace);
